<template>
  <div>
      <ul class="server-item">
          <li>
              <img src="../../assets/img/tools/dayin.png">
              <span>打印机</span>
              <Button type="primary" ghost><router-link to="/Printer">立即购买</router-link></Button>
          </li>
          <!--<li>
              <img src="../../assets/img/tools/dayinserver.png">
              <span>打印服务</span>
              <Button type="primary" ghost><router-link to="/PrinterServer">立即购买</router-link></Button>
          </li>
          <li>
              <img src="../../assets/img/tools/vipserver.png">
              <span>会员认证服务</span>
              <Button type="primary" ghost><router-link to="/vipServer">立即购买</router-link></Button>
          </li>-->
      </ul>
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {

      }
    },

    mounted: function() {
      //DOM更新完后再请求数据
      this.$nextTick(function() {

      });
    },
    created: function() {
      //DOM更新完之前请求数据


    },
    methods: {

    }
  }
</script>

<style  lang="scss" scoped>
.server-title{
    font-size: 20px;display: inline-block; text-align: center;width: 88%
}
.server-item li{
    margin:0 auto 26px;
    position: relative;
    width: 328px;
    height: 75px;
    border-radius: 5px;
    box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
    padding-left: 75px;
    line-height: 75px;
    color: #333333;
    float: left;
    background: #ffffff;
    margin: 20px;
    img{
        position: absolute;
        left: 14px;
        top: 12px;
        width: 50px;
        height: 50px;
    }
    Button{
        position: absolute;
        top: 25px;
        right: 15px;
    }
}
</style>